import React, { FC } from 'react';
import styled from '@emotion/styled';
import { IEnrichedProduct } from '$models';
import { Flex } from '$components/layouts';
import { ProductHeader } from '$templates/product-page/product-header';
import { Description } from './description';
import { Image } from '$components/elements/image';
import { mq } from '$lib/helpers';

type Props = {
    product: IEnrichedProduct;
};

export const About: FC<Props> = ({ product }): JSX.Element => {
    return (
        <Container column>
            <StyledImageContainer>
                <Image height={300} width={400} src={product.imageResources?.[0].url ?? ''} blendMode="darken" />
            </StyledImageContainer>
            <ProductHeader variant={product} simple />
            <Description product={product} />
        </Container>
    );
};

const Container = styled(Flex)({
    width: '100%',
});

const StyledImageContainer = styled.div(({ theme }) => ({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: theme.colors.grey5,
    padding: theme.space[9],
    marginBottom: theme.space[8],
    [mq('md')]: {
        display: 'none',
    },

    '& img': {
        width: 'auto',
        height: 'auto',
        maxHeight: '400px',
    },
}));
